import React, { useEffect, useState } from 'react';
import inversionesExteriorPdfService from '../../../services/inversionesExteriorPdfService';
import '../../../styles/components/CuadraturaPdf.css';

const TIPOS_DOCUMENTO = {
    cartola: 'Cartola',
    reporte_anual: 'Reporte anual',
    contrato: 'Contrato',
    acuerdo: 'Acuerdo de inversión',
    prestamo: 'Préstamo',
    escritura: 'Escritura',
    otro: 'Otro documento'
};

const formatear = (valor) => Number(valor).toLocaleString('es-CL', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

/**
 * Datos del documento y cuadratura de una carga PDF: los totales que imprime el
 * documento (en su moneda) contra la suma de las filas incluidas. No bloquea nada;
 * sirve para ver si la IA dejó algo fuera o lo leyó distinto. Se recarga con la
 * propuesta, así refleja las ediciones.
 *
 * @param {Object} props
 * @param {Object} props.carga - Carga abierta (la de PropuestaCarga)
 * @param {string} props.token - Token de autenticación
 */
const CuadraturaPdf = ({ carga, token }) => {
    const [datos, setDatos] = useState(null);

    useEffect(() => {
        const buscar = async () => {
            try {
                setDatos(await inversionesExteriorPdfService.getCuadratura(carga.id, token));
            } catch {
                setDatos(null);
            }
        };
        buscar();
    }, [carga, token]);

    if (!datos) return null;
    const { tipo_documento: tipo, periodo, anio, moneda, anio_comercial: anioComercial, conceptos } = datos;

    return (
        <div className="invext-cpdf">
            <h3>Documento</h3>
            <p className="invext-cpdf-datos">
                {TIPOS_DOCUMENTO[tipo] ?? 'Documento'}
                {periodo && ` · ${periodo}`}
                {moneda && ` · montos en ${moneda}`}
            </p>
            {anio && anio !== anioComercial && (
                <p className="invext-cpdf-aviso">
                    El documento es de {anio} y la carga es de los movimientos de {anioComercial}: revisa que la inversión
                    siguiera vigente al 31-12 y su valor a esa fecha.
                </p>
            )}

            {conceptos.length === 0 ? (
                <p className="invext-cpdf-nota">El documento no imprime totales, así que no hay cuadratura.</p>
            ) : (
                <div className="invext-cpdf-tabla-wrap">
                    <table className="invext-cpdf-tabla">
                        <thead>
                            <tr>
                                <th>Cuadratura ({moneda})</th>
                                <th className="num">Documento</th>
                                <th className="num">Filas</th>
                                <th className="num">Diferencia</th>
                            </tr>
                        </thead>
                        <tbody>
                            {conceptos.map((concepto) => (
                                <tr key={concepto.titulo} className={concepto.cuadra ? '' : 'no-cuadra'}>
                                    <td>{concepto.titulo}</td>
                                    <td className="num">{formatear(concepto.documento)}</td>
                                    <td className="num">{formatear(concepto.filas)}</td>
                                    <td className="num">{concepto.cuadra ? 'Cuadra' : formatear(concepto.diferencia)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};

export default CuadraturaPdf;
